// extracted by mini-css-extract-plugin
export var stepActive = "_2m-3";
export var stepCompleted = "_2m-4";
export var stepConnectorLine = "_2m-b";
export var stepIndicatorCircle = "_2m-6";
export var stepIndicatorCircleCompleted = "_2m-7";
export var stepIndicatorCircleDefault = "_2m-8";
export var stepIndicatorTextCompleted = "_2m-9";
export var stepIndicatorTextDefault = "_2m-a";
export var stepPending = "_2m-5";
export var wizardContainer = "_2m-1";
export var wizardContent = "_2m-2";
export var wizardModal = "_2m-0";